<template>
  <a-card title="今日报警" :bordered="false" class="today-alarm-card">
    <div class="alarm-list-container">
      <vue-seamless-scroll :data="alarmData" :class-option="scrollOption" class="alarm-scroll-wrapper">
        <div class="alarm-list">
          <div v-for="(item, index) in alarmData" :key="index" class="alarm-item" :class="item.level">
            <div class="alarm-header">
              <div class="left-info">
                <a-tag :color="getLevelColor(item.level)" class="level-tag">{{ item.levelName }}</a-tag>
                <span class="device-name">{{ item.deviceName }}</span>
              </div>
              <span class="alarm-time">{{ item.time }}</span>
            </div>
            <div class="alarm-content">
              {{ item.content }}
            </div>
            <div class="alarm-footer">
              <span class="status-label">状态：</span>
              <span class="status-value" :style="{ color: getStatusColor(item.status) }">{{ item.statusName }}</span>
              <span class="divider">|</span>
              <span class="type-label">类型：</span>
              <span class="type-value">{{ item.typeName }}</span>
            </div>
          </div>
        </div>
      </vue-seamless-scroll>

      <!-- 如果没有数据时展示 -->
      <a-empty v-if="alarmData.length === 0" description="暂无今日报警" />
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'TodayAlarm',
  data () {
    return {
      alarmData: [
        {
          deviceName: '1#沉淀池池液位计',
          time: '09:30:23',
          content: '液位值0.22m，超过高位报警阈值',
          level: 'critical',
          levelName: '特急',
          status: 'unprocessed',
          statusName: '待处理',
          typeName: '液位报警'
        },
        {
          deviceName: '出厂水流量计',
          time: '10:15:45',
          content: '瞬时流量异常，偏离历史平均水平20%',
          level: 'warning',
          levelName: '警告',
          status: 'processing',
          statusName: '处理中',
          typeName: '流量异常'
        },
        {
          deviceName: '2#余氯检测仪',
          time: '10:45:12',
          content: '设备通讯中断，请检查现场线路连接',
          level: 'info',
          levelName: '提醒',
          status: 'unprocessed',
          statusName: '待处理',
          typeName: '通讯故障'
        },
        {
          deviceName: '加药系统3#泵',
          time: '11:20:05',
          content: '电机运行温度过高，当前温度85℃',
          level: 'critical',
          levelName: '特急',
          status: 'unprocessed',
          statusName: '待处理',
          typeName: '设备过热'
        },
        {
          deviceName: '原水进水阀门',
          time: '12:05:30',
          content: '反馈信号丢失，阀门可能卡死',
          level: 'warning',
          levelName: '警告',
          status: 'unprocessed',
          statusName: '待处理',
          typeName: '控制故障'
        }
      ]
    }
  },
  computed: {
    scrollOption () {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停停止
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新view
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止滚动)
        waitTime: 1000 // 单步运动停止的时间
      }
    }
  },
  methods: {
    getLevelColor (level) {
      const colors = {
        critical: '#f5222d',
        warning: '#fa8c16',
        info: '#1890ff'
      }
      return colors[level] || '#999'
    },
    getStatusColor (status) {
      const colors = {
        unprocessed: '#f5222d',
        processing: '#faad14',
        processed: '#52c41a'
      }
      return colors[status] || '#999'
    }
  }
}
</script>

<style lang="less" scoped>
.today-alarm-card {
  .alarm-list-container {
    height: 320px;
    overflow: hidden;

    .alarm-scroll-wrapper {
      height: 100%;
      overflow: hidden;
    }

    .alarm-item {
      background-color: #fff1f0;
      border: 1px solid #ffa39e;
      border-radius: 4px;
      padding: 12px 16px;
      margin-bottom: 12px;
      transition: all 0.3s;

      &.warning {
        background-color: #fff7e6;
        border-color: #ffd591;

        .device-name,
        .alarm-content,
        .alarm-time {
          color: #d46b08;
        }
      }

      &.info {
        background-color: #e6f7ff;
        border-color: #91d5ff;

        .device-name,
        .alarm-content,
        .alarm-time {
          color: #096dd9;
        }
      }

      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transform: scale(1.01);
      }

      .alarm-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .left-info {
          display: flex;
          align-items: center;

          .level-tag {
            margin-right: 8px;
            border-radius: 2px;
            line-height: 18px;
            height: 20px;
            font-size: 12px;
          }

          .device-name {
            color: #cf1322;
            font-weight: 600;
            font-size: 14px;
          }
        }

        .alarm-time {
          color: #f5222d;
          font-size: 13px;
        }
      }

      .alarm-content {
        color: #cf1322;
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 8px;
      }

      .alarm-footer {
        display: flex;
        align-items: center;
        font-size: 12px;
        border-top: 1px dashed rgba(0, 0, 0, 0.05);
        padding-top: 8px;

        .status-label,
        .type-label {
          color: #8c8c8c;
        }

        .status-value {
          font-weight: 500;
        }

        .divider {
          margin: 0 8px;
          color: #f0f0f0;
        }

        .type-label {
          margin-left: 0;
        }

        .type-value {
          color: #595959;
        }
      }
    }
  }
}
</style>
